import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from './layout/layout.component';
import { AuthGuard } from './login/guards/auth.guard';
import { PasswordResetGuard } from './login/guards/password-reset.guard';
import { LoginComponent } from './login/login.component';
import { PasswordRecoveryComponent } from './login/password-recovery/password-recovery.component';
import { PasswordResetComponent } from './login/password-reset/password-reset.component';

/**
 * Break down routes into smaller, reusable pieces inside the same file.
 * This helps reduce Sonar duplication matches without changing behavior.
 */

// Public/auth routes
const PUBLIC_AUTH_ROUTES: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'password-recovery',
    component: PasswordRecoveryComponent,
  },
  {
    path: 'password/reset/:username/:passwordResetToken',
    component: PasswordResetComponent,
    canActivate: [PasswordResetGuard],
  },
];

// Children under authenticated layout
const AUTH_CHILD_ROUTES: Routes = [
  {
    path: 'nash-pro',
    loadChildren: () => import('./pages/modules/pumps-content.module').then((m) => m.PumpContentModule),
  },
  // add more authenticated child routes here as needed
];

// Root-level routes
const routes: Routes = [
  // Default redirect to login
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },

  // Public/auth routes
  ...PUBLIC_AUTH_ROUTES,

  // Authenticated area under Layout
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: AUTH_CHILD_ROUTES,
  },

  // Optional: wildcard 404 route
  // { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules, // optional; remove if not desired
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
